
<template>
    <section class="popup book-edit">

        <h1 v-if="book">Edit: {{book.name}}</h1>
        <h1 v-else>New Book</h1>

        <input type="text" v-model="bookToEdit.name" />
        <button @click="save">Save</button>
        <button @click="cancel">Cancel</button>
    </section>
</template>

<script>
export default {
    name: 'book-edit',
    props: ['book'],

    data(){
        return {
            bookToEdit: null
        }
    },
    created(){
        this.bookToEdit = Object.assign({}, this.book)
    },
    methods: {
        
        save() {
            console.log('Saving', this.bookToEdit)
            this.$emit('save', this.bookToEdit);
        },
        cancel() {
            this.$emit('delete');
        }
    }
}
</script>


// WEBPACK FOOTER //
// BookEdit.vue?e37c8e40